import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';

function ContactPage() {
    const { t } = useTranslation();

    return (
        <div className="contact-page">
            <section className="text-center py-20 lg:py-32" style={{
                border: "1px solid rgba(129, 140, 248, 0.1)",
                borderRadius: "20px",
                background: "linear-gradient(to right, rgba(129, 140, 248, 0.1), transparent, transparent)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
            }}>
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold leading-tight text-gradient">
                        {t('contactPage.title')}
                    </h1>
                    <p className="text-lg md:text-xl mb-12 max-w-2xl lg:py-8 mx-auto with-shadow">
                        {t('contactPage.introText')}
                    </p>
                </div>
            </section>

            {/* Citazione di Seneca */}
            <section className="py-16 lg:py-24">
                <div className="max-w-4xl mx-auto text-center px-4">
                    <div className="relative" style={{padding: "2em"}}>
                        <svg className="absolute top-0 left-0 w-12 h-12 opacity-60 -mt-4 -ml-4 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                            <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                        </svg>
                        <blockquote className="text-2xl md:text-3xl font-serif italic mb-6 main-h-color leading-relaxed">
                            {t('contactPage.senecaQuote')}
                        </blockquote>
                        <div className="text-right">
                            <cite className="text-lg font-semibold text-gradient not-italic">— Seneca</cite>
                            <p className="text-sm text-gray-400 mt-1">{t('contactPage.senecaQuoteSource')}</p>
                        </div>
                        <svg className="absolute bottom-0 right-0 w-12 h-12 opacity-60 -mb-4 -mr-4 transform rotate-180 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                            <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                        </svg>
                    </div>
                </div>
            </section>

            {/* Informazioni di contatto */}
            <section className="py-20 lg:py-12" id="contact">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl font-bold text-center mb-12 main-h-color">
                        {t('contactPage.getInTouch')}
                    </h2>

                    <div className="grid md:grid-cols-2 gap-8 items-start">
                        <div>
                            <div className="contact-item mb-8">
                                <h3 className="text-xl font-bold mb-4 main-h-color">
                                    {t('contactPage.email')}
                                </h3>
                                <a href="mailto:asksenecatoday@gmail.com"
                                   className="text-gradient text-lg font-semibold hover:opacity-80 transition-opacity">
                                    asksenecatoday@gmail.com
                                </a>
                            </div>

                            <div className="social-section">
                                <h3 className="text-xl font-bold mb-4 main-h-color">
                                    {t('contactPage.followUs')}
                                </h3>
                                <div className="space-y-3">
                                    <a href="https://www.facebook.com/profile.php?id=61586680482590"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       className="flex items-center text-gradient font-semibold hover:opacity-80 transition-opacity">
                                        <span className="mr-3">📘</span> Facebook
                                    </a>
                                    <a href="https://www.instagram.com/senecatoday_com/"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       className="flex items-center text-gradient font-semibold hover:opacity-80 transition-opacity">
                                        <span className="mr-3">📷</span> Instagram
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="additional-info">
                                <p className="with-shadow">
                                    {t('contactPage.collaboration')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ContactPage;

